import { render, staticRenderFns } from "./TaskSummary.vue?vue&type=template&id=57a21979"
import script from "./TaskSummary.vue?vue&type=script&lang=js"
export * from "./TaskSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports